import $ from 'jquery';
$(document).ready(function () {
    // Get elements for dropdown menu 
    var dropdownClick = document.querySelector('.menu-item-has-children').firstChild;
    var dropdown = document.querySelector('.sub-menu');
    dropdown.style.display = "none";
    dropdownClick.addEventListener('click', function () {
        if (dropdown.style.display === "none") {
            dropdown.style.display = "block";
        }
        else {
            dropdown.style.display = "none";
        }
    }); // Get elements needed for mobile burger menu
    var burger = document.querySelector('.burger');
    var navHolder = document.querySelector('.nav-holder');
    burger.addEventListener('click', function () {
        navHolder.classList.toggle('hidden');
    }); // Get elements for dropdown menu inside mobile menu
    var mobDropdownClick = document.querySelector('.nav-holder').querySelector('.menu-item-has-children').firstChild;
    var mobDropdown = document.querySelector('.nav-holder').querySelector('.menu-item-has-children').querySelector('.sub-menu');
    mobDropdown.style.display = "none";
    mobDropdownClick.addEventListener('click', function () {
        // alert('it works');
        if (mobDropdown.style.display === "none") {
            mobDropdown.style.display = "block";
        }
        else {
            mobDropdown.style.display = "none";
        }
    });
});
